import React, { useEffect, useState } from "react";
import { NavLink, useParams, useSearchParams } from "react-router-dom";
import { Toolbar } from "../../layout/Toolbar/Toolbar";
import { InformacionProcesoParticipacion } from "../../components/ProcesosDeCalificacion/InformacionProcesoParticipacion";
import { Filtrar } from "../../components/EtapasDeCalificacion/Filtrar";
import { Cargando } from "../../components/Otros/Cargando";
import { cargarDatosProceso } from "../../utils/Datos";

export const ListarPorProceso = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const { idProcess } = useParams();
  //const idProcess = searchParams.get("idProcess");

  const [updateProceso, setUpdateProceso] = useState(true);
  const [datosProceso, setDatosProceso] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);

  const [datosFiltro, setdatosFiltro] = useState(null);

  useEffect(() => {
    cargarDatosProceso(idProcess).then((p) => {
      setCargandoDatos(false);
      setDatosProceso(p);
      setUpdateProceso(false);
    });
    /* async function cargar() {
      const url = "process/" + idProcess;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status==200) {
            return response.json();
          }else{
            return null;
          }
          
        })
        .then((datos) => {
          //console.log("Fetch editarProceso");
          //console.log(datos);
          if (datos!==null) {
          
            setCargandoDatos(false);
            setDatosProceso(datos);
            setUpdateProceso(false);
          }
         
        });
    }
    if (updateProceso === true && cargandoDatos === false) {
      cargar();
    }*/
  }, []);

  let toolbarEnlaces = [
    {
      muted: "true",
      to: "/editarProceso",
      title: "Home",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "true",
      to: "/buscarProceso",
      title: "Buscar Proceso de Calificación",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "false",
      to: null,
      title: "Participación en proceso",
      bullet: "false",
    },
  ];
  return updateProceso === true || cargandoDatos === true ? (
    <Cargando
      cargandoDatos={cargandoDatos}
      texto={`Cargando información del proceso`}
    ></Cargando>
  ) : (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Toolbar
        title="Participación del proceso"
        enlaces={toolbarEnlaces}
      />

      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder text-dark">
                       INFORMACIÓN DEL PROCESO
                    </span>
                  </h3>
                </div>

                <div className="card-body">
                  <InformacionProcesoParticipacion
                    key="-editar_proceso"
                    proceso={datosProceso}
                    setUpdateProceso={setUpdateProceso}
                  />
                </div>
              </div>
            </div>

            {/*  */}
            <Filtrar setdatosFiltro={setdatosFiltro} idProcess={idProcess} />

            <pre></pre>

            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-header ">
                  <h3 className="card-title align-items-start flex-column ">
                    <span className="card-label fw-bolder text-dark ">
                      Resultados de la búsqueda
                    </span>
                  </h3>
                </div>

                <div className="card-body ">
                  <div className="table-responsive">
                    <table className="table table-rounded table-striped border gy-7 gs-7">
                      <thead>
                        <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                          <th>ID</th>
                          <th>Dirección</th>
                          <th>Precalificador</th>
                          <th>Funcionario</th>
                          <th>Eval1</th>
                          <th>Eval2</th>
                          <th>Precal</th>
                          <th>Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {datosFiltro === null || datosFiltro === [] ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No se encontraron datos con los filtros de
                              busqueda.
                            </td>
                          </tr>
                        ) : (
                          datosFiltro.map((dato, index) => {
                            return (
                              <tr key={"tr_" + index}>
                                <td>{dato.id_participant}</td>
                                <td>{dato.nameMunicipalDirection}</td>
                                <td>{dato.prequalifierName}</td>
                                <td>{dato.nameOfficer}</td>
                                <td>
                                  {dato.dateFirstEvaluation !== null
                                    ? <i className="fas fa-check text-success" />
                                    : <i className="fas fa-times text-danger" />}
                                </td>
                                <td>
                                  {dato.dateSecondEvaluation !== null
                                     ? <i className="fas fa-check text-success" />
                                     : <i className="fas fa-times text-danger" />}
                                </td>
                                <td>
                                  {dato.datePrevEvaluation !== null
                                     ? <i className="fas fa-check text-success" />
                                     : <i className="fas fa-times text-danger" />}
                                </td>
                                <td>
                                  <NavLink
                                    to={`/verProcesoFuncionario/${idProcess}/${dato.id_participant}`}
                                    className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                                  >
                                     ver
                                  </NavLink>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
